import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem } from '../../../core/interfaces/admin.interface';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';
import { TranslatorService } from '../../../core/translator/translator.service';

@Component({
  selector: 'sacbo-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss']
})
export class LanguageSelectComponent {

  @Input() languageSelected: MultiselectItem[] = [];
  @Output() languageSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  languagesList: MultiselectItem[] = [];

  constructor(
    private translatorService: TranslatorService
  ) {
    this.loadMultiselectItems();
  }

  loadMultiselectItems(): void {

    this.languagesList = this.translatorService.getAvailableLanguages().map(lan => {

      return {
        id: lan.code,
        itemName: lan.text
      } as MultiselectItem

    });
  }

  onLanguageSelect(): void {
    this.languageSelectedChange.emit(this.languageSelected);
    this.onSelected.emit(this.languageSelected);
  }

}
